import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Import from project
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import DialogDelete from "../../Utils/DialogDelete";
import SecretaryInMandateForm from "./SecretaryInMandateForm";
import { DELETE_SECRETARY_IN_MANDATE } from "../../Schema/Secretarait";

export default function SecretaryInMandateAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [deleteSecretaryInMandate] = useMutation(DELETE_SECRETARY_IN_MANDATE, {
    onCompleted: ({ deleteSecretaryInMandate }) => {
      setLoading(false);
      if (deleteSecretaryInMandate?.isSuccess === true) {
        setAlert(true, "success", deleteSecretaryInMandate?.message);
        handleCloseDel();
        setRefetch();

      } else {
        setAlert(true, "error", deleteSecretaryInMandate?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteSecretaryInMandate({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        {/* {hasPermission(userLogin?.user?.role, "update:user") && ( */}
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        {/* )} */}

        {/* {hasPermission(userLogin?.user?.role, "delete:user") && ( */}
        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        {/* )} */}
      </Stack>

      {openEdit && (
        <SecretaryInMandateForm
          open={openEdit}
          handleClose={handleCloseEdit}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle="Update"
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_candidate")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
